// theme.js
export default {
  breakpoints: ['48em', '68em', '84em'],
  space: [0, 4, 8, 16, 32, 48, 64, 96, 128, 256, 512],
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 40, 48, 64],
  fonts: {
    sans: '-apple-system, BlinkMacSystemFont, "avenir next", avenir, "helvetica neue", helvetica, ubuntu, roboto, noto, "segoe ui", arial, sans-serif',
    mono: 'Menlo, monospace'
  },
  fontWeights: [400, 500, 600],
  lineHeights: {
    solid: 1,
    title: 1.25,
    copy: 1.5
  },
  colors: {
    // text colors
    black: 'hsl(228, 62%, 9%)',
    gray90: 'hsl(228, 28%, 18%)',
    gray80: 'hsl(227, 17%, 27%)',
    gray70: 'hsl(228, 11%, 36%)',
    // surface colors
    gray30: 'hsl(227, 6%, 73%)',
    gray20: 'hsl(230, 7%, 82%)',
    gray10: 'hsl(220, 6%, 91%)',
    gray5: 'hsl(240, 4%, 95%)',
    gray3: 'hsl(0, 0%, 97%)',
    gray1: 'hsl(0, 0%, 98%)',
    grey: 'hsla(0, 0%, 0%, 0.7)',
    light: 'hsla(0, 0%, 0%, 0.4)',
    lighter: 'hsl(230, 6.5%, 82%)',
    lightest: 'hsla(0, 0%, 0%, 0.05)',
    white: 'hsl(0, 0%, 100%)',
    green: 'hsl(146.6, 83.1%, 44.1%)',
    blue: '#hsl(234.9, 100%, 63.1%)'
  },
  letterSpacings: {
    small: '1px',
    large: '2px'
  },
  shadows: {
    xsmall: '0 0 3px rgba(0, 0, 0, .125)',
    small: '0 0 4px rgba(0, 0, 0, .125)',
    large: '0 0 24px rgba(0, 0, 0, .125)'
  },
  buttons: {
    primary: {
      color: '#fff',
      backgroundColor: 'hsl(234.9, 100%, 63.1%)',
      '&:hover': {
        color: '#fff',
        backgroundColor: 'hsl(234.9, 100%, 60.1%)',
        textDecoration: 'none'
      },
      '&:active': {
        outline: '3px solid hsl(233.7, 100%, 92.5%)',
        outlineOffset: '0'
      },
      '&:focus': {
        outline: '3px solid hsl(233.7, 100%, 92.5%)',
        outlineOffset: '0'
      }
    },
    secondary: {
      color: 'hsl(227, 17%, 27%)',
      backgroundColor: 'hsla(0, 0%, 0%, 0.05)',
      '&:hover': {
        color: 'hsl(227, 17%, 27%)',
        backgroundColor: 'hsla(0, 0%, 0%, 0.08)',
        textDecoration: 'none'
      },
      '&:active': {
        outline: '3px solid hsl(233.7, 100%, 92.5%)',
        outlineOffset: '0'
      },
      '&:focus': {
        outline: '3px solid hsl(233.7, 100%, 92.5%)',
        outlineOffset: '0'
      }
    },
    secondaryActive: {
      color: 'hsl(227, 17%, 27%)',
      backgroundColor: 'hsla(0, 0%, 0%, 0.08)',
      '&:hover': {
        color: 'hsl(227, 17%, 27%)',
        backgroundColor: 'hsla(0, 0%, 0%, 0.08)',
        textDecoration: 'none'
      },
      '&:active': {
        outline: '3px solid hsl(233.7, 100%, 92.5%)',
        outlineOffset: '0'
      },
      '&:focus': {
        outline: '3px solid hsl(233.7, 100%, 92.5%)',
        outlineOffset: '0'
      }
    }
  },
  width: [16, 32, 64, 128, 256],
  heights: [16, 32, 64, 128, 256],
  maxWidths: [16, 32, 64, 128, 256, 512, 768, 1024, 1536]
}
